import { render, staticRenderFns } from "./OverallNode.vue?vue&type=template&id=64a3545d&scoped=true&"
import script from "./OverallNode.vue?vue&type=script&lang=js&"
export * from "./OverallNode.vue?vue&type=script&lang=js&"
import style0 from "./OverallNode.vue?vue&type=style&index=0&id=64a3545d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a3545d",
  null
  
)

export default component.exports